export function saveToLocalStorage(recName, data) {
	localStorage.setItem(recName, JSON.stringify(data))
}

export function generateDynamicHeaders(data, groups) {
	if(data.length > 0 && data[0][groups]) {
		const generatedHeaders = data[0][groups].map((item, i) => {
			return {
				caption: item.label,
				dataField: `${groups}[${i}].value`,
				width: 150,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			}
		})
		return generatedHeaders
	}
	return []
}
